var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"ctes-mdfe-page pa-8 pt-12",attrs:{"fluid":""}},[_c('div',{staticClass:"ctes-mdfe-header"},[_c('div',[_c('h1',{staticClass:"ctes-mdfe-title"},[_vm._v("CT-e / MDF-e")]),_c('p',{staticClass:"ctes-mdfe-subtitle"},[_vm._v(" Modulo de documentos fiscais de transporte. ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }